// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oslzwjyyhugvrzrnwhuc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9zbHp3anl5aHVndnJ6cm53aHVjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2NTgwMTQsImV4cCI6MjA3MjIzNDAxNH0.Aiph-i4szU1ZHIdR-H2w4dMQAqtTqyzSlY3-oza3vus";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});